import { Box, Button, Typography } from '@mui/material'
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings'
import { Stats } from 'store/companySearch/types'
import { useState } from 'react'

type Props = {
  status: string | undefined
  stats: Stats | undefined
}

export function CompanySearchLogs({ status, stats }: Props) {
  const [showLogs, setShowLogs] = useState(false)

  if (!stats) return <Typography fontWeight="bold">Status: {status}</Typography>

  return (
    <Box>
      <Button variant="contained" onClick={() => setShowLogs(!showLogs)}>
        {showLogs ? (
          <>Hide logs</>
        ) : (
          <>
            {' '}
            Show logs (admin only <AdminPanelSettingsIcon /> )
          </>
        )}
      </Button>
      {showLogs && (
        <Box mt={2}>
          <Typography fontWeight="bold">Status: {status}</Typography>
          {stats?.errorMessage && <Typography color="error">{stats?.errorMessage}</Typography>}
          {stats?.winningPatents && (
            <Box mt={2}>
              Winning patents ({stats?.winningPatents.length}):{' '}
              <Typography fontSize={14}>{stats?.winningPatents.join(', ')}</Typography>
            </Box>
          )}
          <Typography mt={4} fontWeight="bold">
            Logs:
          </Typography>

          {stats?.logs.map(row => (
            <Typography pb={0.5} fontSize={14} sx={{ whiteSpace: 'pre' }}>
              {row}
            </Typography>
          ))}
        </Box>
      )}
    </Box>
  )
}
